/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Route } from 'framework/routing';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import ProjectWeeklyReportContext from 'domain/projects/project/weeklyreports/ProjectWeeklyReportContext';
import ProjectWeeklyReportList from 'domain/projects/project/weeklyreports/List';
import ViewProjectWeeklyReport from 'domain/projects/project/weeklyreports/show';
import { GlobalProtectedRoute } from 'framework/authorization';
import {
  READ_PROJECT_REPORTS_LIST,
  READ_PROJECT_WEEKLY_REPORT,
  UPDATE_PROJECT_WEEKLY_REPORT,
} from 'domain/projects/project/weeklyreports/ProjectWeeklyReportService';
import UpdateProjectWeeklyReport from 'domain/projects/project/weeklyreports/update';
import { useProjectWeeklyReportRoute } from 'domain/shared/project';

const ProjectWeeklyReportRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute, singleEntityRoute, updateRoute } = useProjectWeeklyReportRoute();

  return (
    <Routes>
      <Route
        path={listRoute}
        element={
          <GlobalProtectedRoute globalPermissionToCheck={READ_PROJECT_REPORTS_LIST}>
            <ProjectWeeklyReportList />
          </GlobalProtectedRoute>
        }
      />

      <Route
        path={singleEntityRoute}
        element={
          <ProjectWeeklyReportContext permissionToCheck={READ_PROJECT_WEEKLY_REPORT}>
            <ViewProjectWeeklyReport />
          </ProjectWeeklyReportContext>
        }
      />

      <Route
        path={updateRoute}
        element={
          <ProjectWeeklyReportContext permissionToCheck={UPDATE_PROJECT_WEEKLY_REPORT}>
            <UpdateProjectWeeklyReport />
          </ProjectWeeklyReportContext>
        }
      />

      <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
    </Routes>
  );
};

export default ProjectWeeklyReportRouter;
